/* eslint-disable no-param-reassign */
/* eslint-disable prefer-const */
import { rgb } from "d3-color"

/**
 *
 * @export
 * @param {string} str
 */
export function copyToClipboard(str: string) {
  const el = document.createElement("input")
  el.setAttribute("readonly", "readonly") // 防止手机上弹出软键盘
  el.setAttribute("value", str)
  document.body.appendChild(el)
  el.select()
  document.execCommand("copy")
  document.body.removeChild(el)
}

export function reducer(accumulator: any, currentValue: string) {
  let [key, val] = currentValue.split("=")

  key = key.trim()

  if (!key) {
    return accumulator
  }

  if (val) {
    val = val.trim()
  }

  accumulator[key] = val

  return accumulator
}

/**
 * 解析查询参数
 */

export function urlParse() {
  const hash: string = window.location.href
  const parsed = Object.create(null)

  if (!hash.split("?")[1]) {
    return parsed
  }
  return hash.split("?")[1].split("&").reduce(reducer, parsed)
}

export function parseQuery(qs: string) {
  const parsed = Object.create(null)

  if (qs && qs.split("?")[1]) {
    return qs.split("?")[1].split("&").reduce(reducer, parsed)
  }
  return parsed
}

/**
 * @desc 深拷贝，支持常见类型
 * @param {Any} values
 */
export function deepClone(values: any) {
  let copy: any

  // Handle the 3 simple types, and null or undefined
  if (null == values || "object" != typeof values) return values

  // Handle Date
  if (values instanceof Date) {
    copy = new Date()
    copy.setTime(values.getTime())
    return copy
  }

  // Handle Array
  if (values instanceof Array) {
    copy = []
    for (let i = 0, len = values.length; i < len; i++) {
      copy[i] = deepClone(values[i])
    }
    return copy
  }

  // Handle Object
  if (values instanceof Object) {
    copy = {}
    for (const attr in values) {
      if (values.hasOwnProperty(attr)) copy[attr] = deepClone(values[attr])
    }
    return copy
  }

  throw new Error("Unable to copy values! Its type isn't supported.")
}

/**
 * 对象浅复制
 * @param {object} values
 * @returns
 */
export function shallowCopy(values: Record<string, any>) {
  const o = Object.create(null)

  for (const key in values) {
    o[key] = values[key]
  }

  return o
}

export function dataWithComma(data: string | number) {
  if (!data) {
    return 0
  }
  const reg = /(\d{1,3})(?=(\d{3})+(\.\d*)?$)/g
  const num = data + ""
  return num.replace(reg, "$1,")
}

export function isElementInViewport(el: HTMLElement) {
  const rect = el.getBoundingClientRect()
  return rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight)
}

/**
 * 数字增加百分号
 * @param data
 */

export function toPercent(point: number) {
  if (point === 0) {
    return 0
  }
  let str = Number(point * 100).toFixed(2)
  str += "%"
  return str
}

export function downloadFile(content: Blob, fileName: string) {
  const eleLink = document.createElement("a")
  eleLink.download = fileName
  eleLink.style.display = "none"
  const href = window.URL.createObjectURL(content)
  eleLink.href = href
  document.body.appendChild(eleLink)
  eleLink.click()
  document.body.removeChild(eleLink)
  window.URL.revokeObjectURL(href)
}

export function uuid() {
  const s = []
  const hexDigits = "0123456789abcdef"
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = "4" // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr(((s[19] as any) & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-"

  const uuid = s.join("")
  return uuid
}

/**
 *
 * @export
 * @param {number} number
 * @param {number} precision
 * @returns
 */
export function round(number: number, precision: number) {
  return Math.round((+number + "e" + precision) as unknown as number) / Math.pow(10, precision)
}

/**
 ** 加法函数，用来得到精确的加法结果
 ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
 ** 调用：accAdd(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
export function accAdd(arg1: number, arg2: number) {
  let r1, r2, m, c
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  c = Math.abs(r1 - r2)
  m = Math.pow(10, Math.max(r1, r2))
  if (c > 0) {
    const cm = Math.pow(10, c)
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace(".", ""))
      arg2 = Number(arg2.toString().replace(".", "")) * cm
    } else {
      arg1 = Number(arg1.toString().replace(".", "")) * cm
      arg2 = Number(arg2.toString().replace(".", ""))
    }
  } else {
    arg1 = Number(arg1.toString().replace(".", ""))
    arg2 = Number(arg2.toString().replace(".", ""))
  }
  return (arg1 + arg2) / m
}

/**
 ** 减法函数，用来得到精确的减法结果
 ** 说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
 ** 调用：accSub(arg1,arg2)
 ** 返回值：arg1加上arg2的精确结果
 **/
export function accSub(arg1: number, arg2: number) {
  let r1, r2, m, n
  try {
    r1 = arg1.toString().split(".")[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split(".")[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2)) //last modify by deeka //动态控制精度长度
  n = r1 >= r2 ? r1 : r2
  return Number(((arg1 * m - arg2 * m) / m).toFixed(n))
}

/**
 ** 乘法函数，用来得到精确的乘法结果
 ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 ** 调用：accMul(arg1,arg2)
 ** 返回值：arg1乘以 arg2的精确结果
 **/
export function accMul(arg1: number, arg2: number) {
  let m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString()
  try {
    m += s1.split(".")[1].length
  } catch (e) {}
  try {
    m += s2.split(".")[1].length
  } catch (e) {}
  return (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) / Math.pow(10, m)
}

/**
 ** 除法函数，用来得到精确的除法结果
 ** 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
 ** 调用：accDiv(arg1,arg2)
 ** 返回值：arg1除以arg2的精确结果
 **/
export function accDiv(arg1: number, arg2: number) {
  let t1 = 0,
    t2 = 0,
    r1,
    r2
  try {
    t1 = arg1.toString().split(".")[1].length
  } catch (e) {}
  try {
    t2 = arg2.toString().split(".")[1].length
  } catch (e) {}
  r1 = Number(arg1.toString().replace(".", ""))
  r2 = Number(arg2.toString().replace(".", ""))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}

/**
 * 获取echarts 线性渐变色
 */
export function getLinearColor(color: string[], xy = [0, 0, 0, 1]) {
  const [c1, c2] = color
  const [x, y, x2, y2] = xy

  return {
    type: "linear",
    x,
    y,
    x2,
    y2,
    colorStops: [
      {
        offset: 0,
        color: c1, // 0% 处的颜色
      },
      {
        offset: 1,
        color: c2, // 100% 处的颜色
      },
    ],
    global: false, // 缺省为 false
  } as any
}
// 获取随机HSL
function randomHsl() {
  const H = Math.random()
  const S = Math.random()
  const L = Math.random()
  return [H, S, L]
}

function getHslArray(length: number) {
  const HSL = []
  const hslLength = length // 获取数量
  for (let i = 0; i < hslLength; i++) {
    let ret = randomHsl()

    // 颜色相邻颜色差异须大于 0.25
    if (i > 0 && Math.abs(ret[0] - HSL[i - 1][0]) < 0.25) {
      i--
      continue // 重新获取随机色
    }
    // ret[1] = 0.7 + (ret[1] * 0.2); // [0.7 - 0.9] 排除过灰颜色
    // ret[2] = 0.4 + (ret[2] * 0.4); // [0.4 - 0.8] 排除过亮过暗色
    ret[1] = 0.6 + ret[1] * 0.4 // [0.6 - 1] 排除过灰颜色
    ret[2] = 0.4 + ret[2] * 0.5 // [0.4 - 0.9] 排除过亮过暗色

    // 数据转化到小数点后两位
    ret = ret.map(function (item) {
      return parseFloat(item.toFixed(2))
    })

    HSL.push(ret)
  }
  return HSL
}

/**
 * HSL颜色值转换为RGB
 * H，S，L 设定在 [0, 1] 之间
 * R，G，B 返回在 [0, 255] 之间
 *
 * @param H 色相
 * @param S 饱和度
 * @param L 亮度
 * @returns Array RGB色值
 */
function hslToRgb(H: number, S: number, L: number) {
  let R, G, B
  if (+S === 0) {
    R = G = B = L // 饱和度为0 为灰色
  } else {
    const hue2Rgb = function (p: number, q: number, t: number) {
      if (t < 0) t += 1
      if (t > 1) t -= 1
      if (t < 1 / 6) return p + (q - p) * 6 * t
      if (t < 1 / 2) return q
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
      return p
    }
    const Q = L < 0.5 ? L * (1 + S) : L + S - L * S
    const P = 2 * L - Q
    R = hue2Rgb(P, Q, H + 1 / 3)
    G = hue2Rgb(P, Q, H)
    B = hue2Rgb(P, Q, H - 1 / 3)
  }
  return [Math.round(R * 255), Math.round(G * 255), Math.round(B * 255)]
}

/**
 * 生成随机颜色
 *
 * @export
 * @returns
 */
export function getRandomColors(length: number) {
  return getHslArray(length).map(([H, S, L]) => {
    const [r, g, b] = hslToRgb.call(undefined, H, S, L)
    return rgb(r, g, b).toString()
  })

  // return "hsl(" + Math.random() + ", 1, 1)"
}

/**
 * 洗牌算法
 */
export function shuffle(arr: any) {
  arr = arr.slice()
  for (let i = arr.length - 1; i >= 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1))
    const itemAtIndex = arr[randomIndex]
    arr[randomIndex] = arr[i]
    arr[i] = itemAtIndex
  }
  return arr
}

/**
 * 将tree数据解构
 */
export function parseTreeJson(data: any[], result: any[] = []) {
  for (let i = 0; i < data?.length; i++) {
    const node = data[i]
    const { children, ...others } = node
    result.push({ ...others })
    if (node.children) {
      result.push(...parseTreeJson(node.children))
    }
  }
  return result
}

/**
 * 获取上一级的父级id
 */
export const getParentId: any = (tree: any[], id: string, idField: string = "id") => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some((item: any) => item?.[idField] === id)) {
        parentKey = node?.[idField]
      } else if (getParentId(node.children, id, idField)) {
        parentKey = getParentId(node.children, id, idField)
      }
    }
  }
  return parentKey
}

/**
 * 获取当前项的直系所有父级id（包括自己）
 */
export function getAllParentIds(
  array: any[],
  id: string | number,
  idField = "id",
  childrenField = "children",
) {
  const stack: string[] = []
  let going = true
  const walker = (array: any[], id: string | number) => {
    array.forEach((item) => {
      if (!going) return
      stack.push(item[idField])
      if (item[idField] === id) {
        going = false
      } else if (item[childrenField]) {
        walker(item[childrenField], id)
      } else {
        stack.pop()
      }
    })
    if (going) stack.pop()
  }
  walker(array, id)
  return stack
}

/**
 * 获取当前项的所有子级id（不包括自己）
 */
export function getAllChildrenIds(list: any[], id: string, idField = "id") {
  let activeItem: any = null
  const walker: any = (array: any[], key: string) => {
    for (let i = 0; i < array?.length; i++) {
      const item = array[i]
      if (item?.[idField] === key) {
        activeItem = item
        return
      } else {
        if (item?.children) {
          walker(item.children, key)
        }
      }
    }
  }
  walker(list, id)
  const ids = parseTreeJson(activeItem?.children || [])?.map((item) => item?.[idField]) || []
  return ids
}

/**
 * 根据id找到tree中的项
 */
export function getTreeItem(list: any[], id: string | number, idField = "id") {
  for (let i = 0; i < list.length; i++) {
    const item = list[i]
    if (item[idField] == id) {
      return item
    } else {
      if (item?.children) {
        const result: any = getTreeItem(item.children, id, idField)
        if (result) return result
      }
    }
  }
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function getTreeList(data: any[], id = "id", parentId = "parentId", children = "children") {
  const config = {
    id: id,
    parentId: parentId,
    childrenList: children,
  }

  const childrenListMap = {}
  const nodeIds = {}
  const tree = []

  for (let d of data) {
    let parentId = d[config.parentId]
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = []
    }
    nodeIds[d[config.id]] = d
    childrenListMap[parentId].push(d)
  }

  for (let d of data) {
    let parentId = d[config.parentId]
    if (nodeIds[parentId] == null) {
      tree.push(d)
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t)
  }

  function adaptToChildrenList(o: any) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]] || []
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c)
      }
    }
  }
  return tree
}

/**
 * 获取两个坐标点之间的deg和radius
 */
export function getDegAndLength(x1: number, y1: number, x2: number, y2: number) {
  const line1 = Math.abs(x1 - x2)
  const line2 = Math.abs(y1 - y2)
  const deg = Math.round((Math.atan(line2 / line1) * 180) / Math.PI)
  const radius = Math.sqrt(Math.pow(line1, 2) + Math.pow(line2, 2))
  return {
    deg,
    radius,
  }
}

/**
 * 是否无效值（null,undefined,NaN判断）
 */
export function isInvalid(value?: any) {
  return (typeof value === "number" && Number.isNaN(value)) || value === null || value === undefined
}

/**
 * 判断是否是数字
 */
export function isNumber(value?: any): value is number {
  return typeof value === "number" && !Number.isNaN(value)
}

/**
 * 四舍五入到千位，不足千位的四舍五入到百位
 */
export function roundToThousands(num: any) {
  // eslint-disable-next-line
  if (isNumber(num)) {
    if (num >= 1000) {
      return Math.round(num / 1000) * 1000
    } else if (num > 0) {
      return Math.round(num / 100) * 100
    } else {
      return 0
    }
  } else {
    return num
  }
}

/**
 * 计算两个数组的差集
 */
export function getDiffOfArrays(arr1: any[], arr2: any[]) {
  const set1 = new Set(arr1)
  return arr2.filter((v) => !set1.has(v))
}

/**
 * 比较两个数组是否元素相同
 * 注：只可比较基本元素
 */
export function isArrayEqual(arr1: any[], arr2: any[]) {
  if (!arr1 || !arr2) return false
  if (arr1?.length !== arr2?.length) return false
  const cloneArr1 = arr1.slice()
  const cloneArr2 = arr2.slice()
  cloneArr1.sort((a, b) => a - b)
  cloneArr2.sort((a, b) => a - b)
  for (let i = 0; i < cloneArr1.length; i++) {
    if (cloneArr1[i] !== cloneArr2[i]) {
      return false
    }
  }
  return true
}

/**
 * 判断两个对象内容是否相等
 */
export function isObjectValueEqual(a: any, b: any) {
  if (!a || !b) return false
  const aProps = Object.getOwnPropertyNames(a)
  const bProps = Object.getOwnPropertyNames(b)
  if (aProps.length != bProps.length) {
    return false
  }
  for (let i = 0; i < aProps.length; i++) {
    const propName = aProps[i]
    const propA = a[propName]
    const propB = b[propName]
    if (propA !== propB) {
      return false
    }
  }
  return true
}

/**
 * 地图根据多个坐标点, 计算中心点坐标
 */
export function getPointsCenter(points: any[], lngField = "longitude", latField = "latitude") {
  const point_num = points.length //坐标点个数
  let X = 0,
    Y = 0,
    Z = 0
  for (let i = 0; i < points.length; i++) {
    const { [lngField]: longitude, [latField]: latitude } = points[i]
    let lat, lng, x, y, z
    lat = (parseFloat(latitude) * Math.PI) / 180
    lng = (parseFloat(longitude) * Math.PI) / 180
    x = Math.cos(lat) * Math.cos(lng)
    y = Math.cos(lat) * Math.sin(lng)
    z = Math.sin(lat)
    X += x
    Y += y
    Z += z
  }
  X = X / point_num
  Y = Y / point_num
  Z = Z / point_num

  const tmp_lng = Math.atan2(Y, X)
  const tmp_lat = Math.atan2(Z, Math.sqrt(X * X + Y * Y))

  return [(tmp_lng * 180) / Math.PI, (tmp_lat * 180) / Math.PI]
}

/**
 * 修改字段名
 * @export
 * @param {*} data
 * @param {RegExp} reg
 * @param {string} key
 * @returns
 */
export function modifyKey(data: any, reg: RegExp, key: string) {
  return JSON.parse(JSON.stringify(data).replace(reg, key))
}

/**
 * 经纬度有效范围判断
 * @export
 * @param {number} longitude
 * @param {number} latitude
 * @returns {boolean}
 */
export function isValidCoordinate(longitude?: number, latitude?: number): boolean {
  if (!longitude || !latitude) {
    return false
  }
  // 经度是向东到180°或向西到180°
  if (longitude < -180 || longitude > 180) {
    return false
  }

  //纬度 北纬为正数，南纬为负数 最大是90° 最小是-90°
  if (latitude < -90 || latitude > 90) {
    return false
  }
  return true
}

export function getKm(meters: number) {
  return meters >= 1000 ? `${accDiv(meters, 1000)}km` : `${meters}m`
}

// eslint-disable-next-line @typescript-eslint/ban-types
const utils: Record<string, Function> = {
  copyToClipboard,
  urlParse,
  parseQuery,
  shallowCopy,
  deepClone,
  dataWithComma,
  isElementInViewport,
  toPercent,
  downloadFile,
  uuid,
  round,
  accAdd,
  accSub,
  accMul,
  accDiv,
  getLinearColor,
  modifyKey,
}

export function csvJSON(csv: string) {
  const lines = csv.split("\n")

  const result = []

  const headers = lines[0].split(",")

  for (let i = 1; i < lines.length; i++) {
    const obj = Object.create(null)
    const currentline = lines[i].split(",")

    for (let j = 0; j < headers.length; j++) {
      obj[headers[j]] = currentline[j]
    }

    result.push(obj)
  }

  //return result; //JavaScript object
  return JSON.stringify(result) //JSON
}

export function colorHex(colorString: string) {
  const that = colorString
  //十六进制颜色值的正则表达式
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  // 如果是rgb颜色表示
  if (/^(rgb|RGB)/.test(that)) {
    const aColor = that.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",")
    let strHex = "#"
    for (let i = 0; i < aColor.length; i++) {
      let hex = Number(aColor[i]).toString(16)
      if (hex.length < 2) {
        hex = "0" + hex
      }
      strHex += hex
    }
    if (strHex.length !== 7) {
      strHex = that
    }
    return strHex
  } else if (reg.test(that)) {
    const aNum = that.replace(/#/, "").split("")
    if (aNum.length === 6) {
      return that
    } else if (aNum.length === 3) {
      let numHex = "#"
      for (let i = 0; i < aNum.length; i += 1) {
        numHex += aNum[i] + aNum[i]
      }
      return numHex
    }
  }
  return that
}

export function colorRgb(colorString: string) {
  let sColor = colorString.toLowerCase()
  //十六进制颜色值的正则表达式
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  // 如果是16进制颜色
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      let sColorNew = "#"
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    //处理六位的颜色值
    const sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)))
    }
    return "rgb(" + sColorChange.join(",") + ")"
  }
  return sColor
}

export function getRGB(colorString: string) {
  //十六进制颜色值的正则表达式
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  const color = reg.test(colorString) ? colorRgb(colorString) : colorString
  return color.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",")
}

export function dataURLtoBlob(dataurl: string) {
  let arr: any[] = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

export function convertKey(arr: any[], keyMap: Record<string, string>) {
  let tempString = JSON.stringify(arr)
  for (const key in keyMap) {
    const reg = new RegExp(`"${key}":`, "g")
    tempString = tempString.replace(reg, `"${keyMap[key]}":`)
  }
  return JSON.parse(tempString)
}

export function getParentUrl() {
  let url: string = ""
  if (window.parent !== window.self) {
    try {
      url = window.parent.location.href
    } catch (e) {
      url = document.referrer
    }
  }
  return url
}

export function colorToRGBArray(color: string, opacity = 1): [number, number, number, number?] {
  const rgba = rgb(color)
  return [rgba.r, rgba.g, rgba.b, rgba.opacity * opacity * 255]
}

/**
 * requestAnimationFrame计时器
 */
export function getRequestAnimation() {
  const win: any = window
  const requestAnimationFrame =
    win.requestAnimationFrame ||
    win.mozRequestAnimationFrame ||
    win.webkitRequestAnimationFrame ||
    win.msRequestAnimationFrame
  const cancelAnimationFrame = win.cancelAnimationFrame || win.mozCancelAnimationFrame
  let myAnimationRequest: any
  function requestAnimation(callback: () => void, time: number) {
    let i = 1
    myAnimationRequest = requestAnimationFrame(function fn() {
      // 计数器% （60/1秒钟执行的次数）
      const value = (60 / (1000 / time)).toFixed(0)
      if (i % parseFloat(value) === 0) {
        callback()
      }
      i++
      myAnimationRequest = requestAnimationFrame(fn)
    })
  }
  function cancelAnimation() {
    if (myAnimationRequest) {
      cancelAnimationFrame(myAnimationRequest)
      myAnimationRequest = null
    }
  }

  return {
    requestAnimation,
    cancelAnimation,
  }
}

/**
 * 延迟执行
 *
 * @export
 * @param {Function} fn
 * @param {number} delay
 * @return {*}
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function delay(func: Function, wait: number, ...args: any) {
  if (typeof func !== "function") {
    throw new TypeError("Expected a function")
  }
  return setTimeout(func, +wait || 0, ...args)
}

"Boolean|Number|String|Function|Array|Date|RegExp|Object|Error".split("|").forEach(function (type) {
  utils[`is${type}`] = function (obj: any) {
    return {}.toString.call(obj) === `[object ${type}]`
  }
})

export function measureText(content: string, fontSize: string, fontFamily: string = "sans-serif") {
  const canvas = document.createElement("canvas")
  const ctx = canvas.getContext("2d")!
  ctx.font = `${fontSize}px ${fontFamily}`
  return ctx.measureText(content)
}

export function getImageSize(imageUrl: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve) => {
    const image = new Image()
    image.src = imageUrl
    image.onload = function () {
      const width = image.width
      const height = image.height
      resolve({ width, height })
    }
  })
}

export default utils
